import { TranslationService } from "../../../services/TranslationService";
import { InvoiceListDataPlan } from "../InvoiceListDataPlan";

export const DataHistoryInvoice = () => {
  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <h4 className="mb-2">{TranslationService.translate.InvoiceHistory}</h4>
        <div className="card">
          <InvoiceListDataPlan />
        </div>
      </div>
    </div>
  );
};
